import React,{useState} from 'react';
import { NavLink } from 'react-router-dom';
// import bg from '../../images/service.jpg';
import {projectData} from '../../data/projectData';
import './css/recentWork.css';

const RecentWork = () => {
    const [data] = useState(projectData);

    // console.log(data);

    return (
        <div className='recent-work'>
            <h2>recent work</h2>
            <p style={{textAlign:'left',padding:'0'}}>hello world hello world</p>
            
            <div className='recent-work_items'>
                {data.map((d,i)=>{
                    return(
                        <div key={i} className='recent-work_singleitem' data-aos="zoom-in-up" data-aos-duration="1500">
                            <div><img src={d.img} alt='Harshitha developers recent projects' height='100%' width='100%' /></div>
                            <div className='recent-work-heading'>
                                <h3>{d.title}</h3>
                                <NavLink to={`/projects/${d.id}`} className='btn'>more</NavLink>
                            </div>
                            <p>{d.description}</p>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}

export default RecentWork;
